import { useQuery } from 'react-query';
import { useLocation } from 'react-router-dom';
import EmployeeAPI from './api';
import { QUERY_KEY_EMPLOYEE_INFORMATION } from './query-keys';

export function useGetEmployeeInformation(userName) {
  return useQuery(
    [QUERY_KEY_EMPLOYEE_INFORMATION, userName],
    (key, userNameParam) =>
      EmployeeAPI.getEmployeeInformation(userNameParam).then(
        ({ employee: [employeeInformation] }) => employeeInformation
      ),
    {
      enabled: userName,
    }
  );
}

export function useIsEmployeeFlow() {
  const location = useLocation();
  return location.pathname.includes('emple');
}
